import React, { Component } from 'react';
import './portfolio-card.scss';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const customStyles = {
  overlay : {
    zIndex: '1000000'
  }
};

class PortfolioCard extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      photoIndex: 0,
      lightBoxOpen: false
    }
  }
  
  render() {
    const images = this.props.images;

    return (
      <div className="portfolio-card">
        <div className="card-content">
          <div>
            <div className="img-container" onClick={() => {this.setState({lightBoxOpen: true})}}>
              <img className="card-img" src={this.props.imgsrc} alt="" />
              <div className="hover-text-container">
                <div>Click to enlarge</div>
              </div>
            </div>
            <div className="text-container">
              <h1 className="card-title">{this.props.cardTitle}</h1>
              <p className="card-text">{this.props.cardText}</p>
            </div>
          </div>
        </div>
        {this.state.lightBoxOpen && (
          <Lightbox
            reactModalStyle={customStyles}
            enableZoom={false}
            mainSrc={images[this.state.photoIndex]}
            nextSrc={images[(this.state.photoIndex + 1) % images.length]}
            prevSrc={images[(this.state.photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ lightBoxOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (this.state.photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (this.state.photoIndex + 1) % images.length,
              })
            }
          />
        )}
      </div>
    );
  }
}

export default PortfolioCard;



// WEBPACK FOOTER //
// ./src/components/portfolio-card/portfolio-card.js